import { ref, onMounted, computed } from 'vue'
import type { Ref } from 'vue'

export function useValidationError() {
  const $field: Ref<any> = ref(null)

  const fieldValidationErrorMessage = computed(() => {
    if (!$field?.value) return ''

    return $field.value?.errorMessages[0] || ''
  })

  onMounted(() => {
    if (!$field?.value)
      throw new Error('The field from which to take validations must be referenced')
  })

  return {
    $field,
    fieldValidationErrorMessage
  }
}
